import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../auth/auth.service/auth.service';
import {Observable, timer} from 'rxjs';
import {DestroyService} from '../../services/destroy/destroy.service';
import {takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';

@Component({
  selector: 'app-expired-session',
  templateUrl: './expired-session.component.html',
  styleUrls: ['./expired-session.component.scss'],
  providers: [DestroyService],
})
export class ExpiredSessionComponent implements OnInit {

  private readonly redirectTimer$: Observable<number> = timer(3000);

  constructor(private authService: AuthService,
              private destroy$: DestroyService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.redirectTimer$.pipe(
      takeUntil(this.destroy$),
    )
      .subscribe(() => {
        this.logOut();
      });
  }

  async logOut() {
    this.authService.logoff();

    await this.router.navigate([{ outlets: { popup: null } }]);

    this.router.navigate(['/profiles/select']);
  }

}
